import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowBottomLeftCorner: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-bottom-left-corner"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.25 16.25H7.75V11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.25 15.75L13 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowBottomLeftCorner;
